<script lang="ts">
  import Spinner from '$shared/atoms/Spinner/Spinner.svelte';
  import Icon from '$shared/atoms/Icon/Icon.svelte';
  import { ButtonSize } from '$shared/constants/ButtonSize';
  import { ButtonStyle } from '$shared/constants/ButtonStyle';
  import { ButtonType } from '$shared/constants/ButtonType';

  enum SpinnerSize {
    Small = '16px',
    Medium = '18px',
    Large = '20px'
  }

  interface Props {
    disabled?: boolean;
    loading?: boolean;
    size?: ButtonSize | string;
    style?: ButtonStyle | string;
    type?: ButtonType | string;
    maxWidth?: boolean;
    active?: boolean;
    icon?: string;
    tabIndex?: number;
    name?: string;
    onclick?: (e: MouseEvent) => void;
    children?: import('svelte').Snippet;
  }

  let {
    disabled = false,
    loading = false,
    size = '',
    style = ButtonStyle.Secondary,
    type = ButtonType.Button,
    maxWidth = false,
    active = false,
    icon = '',
    tabIndex = 1,
    name = '',
    onclick,
    children
  }: Props = $props();

  const spinnerSize = $derived(
    size === ButtonSize.Large ? SpinnerSize.Large : SpinnerSize.Small
  );

  const isSpinnerLightTheme = $derived(style === ButtonStyle.Primary);

  const iconProps = $derived((() => {
    let color = '';
    if (active) { color = 'active'; }
    if (style === ButtonStyle.Primary || disabled) { color = 'white'; }
    return { value: `${icon} ${color}`, fontSize: '14px', size: '14px' };
  })());
</script>

<button
  {type}
  class="comp-button {size} {style}"
  data-cy={name}
  class:loading
  class:maxWidth
  class:active
  {disabled}
  {tabIndex}
  onclick={(e) => { e.preventDefault(); e.stopPropagation(); onclick?.(e); }}
>
  {#if loading}
    <Spinner light={isSpinnerLightTheme} size={spinnerSize} />
  {:else}
    {#if icon}
      <div class="icon">
        <Icon {...iconProps} />
      </div>
    {/if}
    {@render children?.()}
  {/if}
</button>

<style src="./Button.css">
</style>
